<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div>
          企业名称
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.name"></a-input>
        </div>
        <div class="ml30">
          法人名称
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.corporationName"></a-input>
        </div>
        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
        <div></div>
      </div>
      <div class="search-r">

        <a-button v-if="store.hasPermi('enterprise:add')" @click="add" type="primary"> + 新建</a-button>
        <a-button v-if="store.hasPermi('enterprise:register:review')"  @click="pending" type="primary" class="ml24 pending-btn">
          待审核
          <span v-if="pendingTotal > 0" class="badge">{{ pendingTotal > 99 ? '99++' : pendingTotal }}</span>
        </a-button>

        <a-popconfirm title="操作不可逆，是否删除?" ok-text="是" cancel-text="否" @confirm="delMore">
          <a-button type="primary" class=" ml24"> <i class="iconfont icon-shanchuanniu mr5"></i> 批量删除</a-button>
        </a-popconfirm>
        <!-- <a-button type="primary" class=" ml24"><i class="iconfont icon-piliangdaoruicon mr5"></i> 批量导入</a-button>
          <a-button type="primary" ghost class=" ml24"><i class="iconfont icon-quanbuxiazaiicon mr5"></i> 下载模板</a-button> -->
      </div>
    </div>
    <a-table :columns="columns" :row-key="(record) => record.id" :data-source="dataSource" class="mt23" size="middle"
      :pagination="pagination" :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }" :scroll="{ y: 'auto' }" v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'ranking'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'status'">
          <a-switch v-model:checked="record.status" @change="switchChange(record)" checked-children="启用"
            un-checked-children="禁用" />
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a @click="detail(record)">详情</a>
            <a v-if="store.hasPermi('enterprise:update')" class="ml10" @click="edit(record)">编辑</a>
            <a-popconfirm title="若删除此企业，则此企业相关联的所有信息（比如人员、资质信息、任务信息等）将被一并删除" ok-text="确定" cancel-text="取消" @confirm="del(record)">
              <a v-if="store.hasPermi('enterprise:del')" class="ml10">删除</a>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
    <Drawer ref="DrawerVal" :drawerTitle="drawerTitle" @drawerEvent="drawerEvent"></Drawer>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, } from "vue";
import { useRouter } from "vue-router";

const pendingTotal = ref(0); // 待审核数量，后续可通过API获取
import moment from "moment";
import Drawer from '@/views/enterprise/drawer.vue'
import { message } from 'ant-design-vue'
import { pendingCount, getList, insert, updateById, deleteById, deleteByBatchId,updateStatus } from '@/api/enterprise/index.js'

import useUserStore from '@/store/modules/user'

const store = useUserStore()

const router = useRouter();

const columns = [
  {
    title: "序号",
    key: "ranking",
    width: 90
  },
  {
    title: "企业名称",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "统一信用代码",
    dataIndex: "unifyCode",
    key: "unifyCode",
    width: 200,
  },
  {
    title: "法人姓名",
    key: "corporationName",
    dataIndex: "corporationName",
    // width: 100,
  },
  {
    title: "联系人姓名",
    key: "linkName",
    dataIndex: "linkName",
  },
  {
    title: "联系人电话",
    key: "linkPhone",
    dataIndex: "linkPhone",
  },
  {
    title: "公司地址",
    key: "address",
    dataIndex: "address",
    width:320
  },
  {
    title: "状态",
    key: "status",
    // dataIndex: "status",
  },
  {
    title: "更新时间",
    key: "updateTime",
    dataIndex: "updateTime",
  },
  {
    title: "操作",
    key: "action",
  },
];

let dataSource = ref([]);
let query = reactive({
  name: "",
  corporationName: "",
  reviewStatus: 1, //查询以审核通过的
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});


const drawerTitle = ref('')

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.corporationName = "";
  query.name = "";
  pagination.current = 1;
  getData();
};

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query,id: store.deptId },
  };
  getList(data).then((res) => {
    console.log(res);
    res.data.records.map((item, index) => {
      item.status = item.status === 1 ? true : false;
    });
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};


const switchChange = (record) => {
  console.log(record);
  let status
  switch (record.status) {
    case true:
      status = 1;
      break;
    case false:
      status = 0
      break;
    default:
      status = null
  }
  updateStatus({ id: record.id, status: status }).then(res => {
    console.log(res);
    if (res.code === 200) {
      message.success('修改成功')
      getData()
    }
  })

}

const drawerEvent = (info) => {
  if (drawerTitle.value === '新增') {
    console.log(info);
    insert(info).then(res => {
      if (res.code === 200) {
        message.success('新增成功')
        getData()
      }
    })
  } else {
    console.log(info);
    updateById(info).then(res => {
      if (res.code === 200) {
        message.success('编辑成功')
        getData()
      }
    })
  }
}

onMounted(async () => {
  await getData();
  // 获取待审核数量
  try {
    const res = await pendingCount();
    pendingTotal.value = res.data;
  } catch (error) {
    console.error('获取待审核数量失败:', error);
  }
});

// const detail = (record) => {
//   console.log(record);
//   router.push({
//     path: "/enterpriseManage/enterpriseDetail",
//     query: {
//       modelId: record.id,
//     },
//   });
// };

const DrawerVal = ref(null)
const add = () => {
  console.log(123);
  drawerTitle.value = '新增'
  DrawerVal.value.showDrawer()
}

const pending = () => {

  router.push("/enterpriseManage/review")
}


const edit = (record) => {
  console.log(record);
  drawerTitle.value = '编辑'
  DrawerVal.value.showDrawer(record)
};

const detail = (record) => {
  drawerTitle.value = '详情'
  DrawerVal.value.showDrawer(record)
}

// 多选数据
const selectedRowKeys = ref([]);

const onSelectChange = (value) => {
  console.log("selectedRowKeys changed: ", value);
  selectedRowKeys.value = value;
};

// 批量删除
const delMore = () => {
  if (selectedRowKeys.value.length < 1) {
    message.warning("请选中要删除的数据！");
    return false;
  } else {
    // 删除接口
    deleteByBatchId(selectedRowKeys.value).then((res) => {
      if (res.code === 200) {
        message.success("批量删除成功");
        getData();
      }
    });
  }
};
const del = (record) => {
  console.log(record);
  deleteById(record.id).then((res) => {
    message.success("删除成功");
    getData();
  })

};
</script>

<style lang="less" scoped>

.pending-btn {
  position: relative; /* 确保徽标相对于按钮定位 */
  padding-right: 12px; /* 给徽标留出空间，避免文字被遮挡 */
}

.badge {
  position: absolute;
  top: -6px;       /* 向上微调，使其贴近按钮边缘 */
  right: -6px;     /* 向右微调，使其贴近按钮边缘 */
  background: #ff4d4f; /* 红色背景 */
  color: white;
  border-radius: 10px; /* 圆形效果 */
  min-width: 18px;    /* 最小宽度 */
  height: 18px;       /* 高度 */
  line-height: 18px;  /* 垂直居中 */
  text-align: center; /* 水平居中 */
  font-size: 12px;
  font-weight: bold;
  padding: 0 4px;     /* 左右内边距，避免数字太小时显示不全 */
  box-shadow: 0 0 0 1px #fff; /* 可选：白色边框，增强对比度 */
}

.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767e;
}

/deep/.ant-select-selector {
  background-color: #f2f4f7 !important;
  color: #68767e !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}
</style>